<div class="container-notes-popup content-dialog">
  <form [formGroup]="addNoteForm" class="form">
    <div class="form-group">
      <label for="" class="form-label">Description</label>
      <app-mention-input
        #mentionInput
        formControlName="content"
        [placeholder]="'Enter Description (use @ to mention staff)'"
        [rows]="4"
        (mentionedUsersChange)="onMentionedUsersChange($event)"
      ></app-mention-input>
      <app-form-errors
        [color]="'danger'"
        [form]="addNoteForm"
        [control]="addNoteForm.controls['content']"
      >
      </app-form-errors>
    </div>
    <div class="form__switch">
      <span>Public</span>
      <p-inputSwitch formControlName="is_public"></p-inputSwitch>
    </div>
    <div class="form__actions">
      <button
        class="cancel-btn"
        type="button"
        [disabled]="isLoadingSubmit"
        (click)="dialogRef.close()"
      >
        Cancel
      </button>
      <button
        [disabled]="isLoadingSubmit"
        type="submit"
        class="custom-btn"
        (click)="createNote()"
      >
        {{ note ? "Update" : "Create" }}
        <i *ngIf="isLoadingSubmit" class="fa-spin fas fa-spinner ms-2"></i>
      </button>
    </div>
  </form>
</div>
